import axios from "axios"

// REACT_APP_API_URL (cozido no build pelo CRA) tem prioridade: vem de
// .env.development (dev → http://localhost:2035) ou do build arg do Docker.
// Sem ele, mantém o comportamento antigo (dev na 30035 vs produção). Atenção:
// apontar o dev em localhost para a API de produção NÃO autentica, pois o cookie
// httpOnly é SameSite=Lax e não cruza sites (localhost ≠ api.tryard.com.br).
const baseURL =
    process.env.REACT_APP_API_URL ||
    (window.location.port === "30035"
        ? "http://localhost:3000"
        : "https://api.nanoplay.app/")

// withCredentials: o browser envia/recebe o cookie httpOnly do access token
// automaticamente. O JS nunca toca no token (imune a XSS).
const api = axios.create({
    baseURL,
    withCredentials: true,
})

export const setupAxiosInterceptors = () => {
    // Sessão inválida (cookie ausente/expirado e sem refresh) → volta ao login.
    api.interceptors.response.use(
        (response) => response,
        (error) => {
            if (error.response?.status === 401) {
                alert(
                    "Você foi desconectado. Faça login novamente para continuar.\n\n" +
                        JSON.stringify(error.response.data),
                )
                localStorage.removeItem("user")
                if (!window.location.pathname.startsWith("/login")) {
                    window.location.href = "/login"
                }
            }
            return Promise.reject(error)
        },
    )
}

export default api
